import { defineComponent, PropType } from "vue";
import { mapState } from "pinia";

import {
    IDiagnosis,
    IDiagnosisChangeParameter,
    IDisplayDiagnosis
} from "../../../../../../resources-vue/vue-interfaces/i-diagnosis";
import { formatDate, formatDateInput } from "../../../../../../common/vue-helpers/modifiers/value-modifier";
import { useConvertToPendingPal } from "../../../store/useConvertToPendingPal";

import DatePicker from "../../../../../../resources-vue/vue-custom-elements/DatePicker/DatePicker.vue";
import EmptyTextHandler from "../../../../../../resources-vue/vue-custom-elements/EmptyTextHandler/EmptyTextHandler.vue";
import TablePrompt from "../../../../../../resources-vue/vue-custom-elements/TablePrompt/TablePrompt.vue";
import Diagnosis from "../../../../../../resources-vue/vue-custom-elements/Diagnosis/Diagnosis.vue";

export default defineComponent({
    components: {
        DatePicker,
        EmptyTextHandler,
        TablePrompt,
        Diagnosis
    },

    props: {
        diag: {
            type: Object as PropType<IDisplayDiagnosis>,
            default: null
        },
        isAddRequested: {
            type: Boolean,
            default: false
        },
        index: {
            type: Number
        },
        currentView: {
            type: String
        },
        first: {
            type: Boolean,
            default: false
        },
        last: {
            type: Boolean,
            default: false
        },
        columns: {
            type: Number,
            default: 0
        },
        moveDiagnosisDown: {
            type: Function
        },
        moveDiagnosisUp: {
            type: Function
        },
        deleteDiagnosis: {
            type: Function
        },
        saveNewDiagnosis: {
            type: Function
        },
        cancelSaveNewDiagnosis: {
            type: Function
        }
    },

    data(vm) {
        return {
            originalDiag: null as IDisplayDiagnosis,
            isEditRequested: false as boolean,
            isDeleteRequested: false as boolean,
            selectedDiagnosis: null as IDiagnosis,
            deleteMessage: `Do you want to delete this diagnosis?` as string,
            formatDateInput,
            formatDate
        };
    },

    emits: ["cancelEditDiagChanges", "update:isAddRequested"],

    computed: {
        ...mapState(useConvertToPendingPal, ["application"])
    },

    methods: {
        diagnosisChanged(newDiagnosis: IDiagnosisChangeParameter) {
            if (newDiagnosis) {
                this.diag.code = newDiagnosis.newDiagnosis.code;
                this.diag.description = newDiagnosis.newDiagnosis.description;
                this.diag.billable = newDiagnosis.newDiagnosis.billable;
            }
        },
        openEditDiagnosis() {
            this.originalDiag = { ...this.diag };
            if (this.diag.code !== null) {
                this.selectedDiagnosis = {
                    code: this.diag.code,
                    description: this.diag.description,
                    billable: this.diag.billable
                };
            }
            this.isEditRequested = true;
        },
        openDeleteDiagnosis() {
            this.isDeleteRequested = true;
        },

        cancelDeleteRequest() {
            this.isDeleteRequested = false;
        },

        async saveEditDiagnosis() {
            this.isEditRequested = false;
            this.originalDiag = { ...this.diag };
            this.selectedDiagnosis = null;
        },
        cancelEditDiagnosis() {
            this.isEditRequested = false;
            this.$emit("cancelEditDiagChanges", { ...this.originalDiag }, this.index);
            this.selectedDiagnosis = null;
        },
        async save() {
            this.$emit("update:isAddRequested", false);
            this.originalDiag = { ...this.diag };
            this.selectedDiagnosis = null;
            this.saveNewDiagnosis(this.index);
        },
        handleDateChange(date: string, name: string) {
            if (name === "resolvedDate") {
                this.diag.resolvedDate = date;
            }
            if (name === "startDate") {
                this.diag.startDate = date;
            }
        },
        handleDate(e: any) {
            const name = e.target.name;
            const value = e.target.value;
            this.handleDateChange(value, name);
        },
        handleDeleteDiagnosis() {
            this.deleteDiagnosis(this.index);
        }
    }
});
